import { useRef, useState } from 'react';
import { BriefcaseBusiness, Camera, Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../login/ux/hooks/useAuth';

const LINKS = [
  { href: '#work', label: 'Work' },
  { href: '#brands', label: 'Brands' },
  { href: '#services', label: 'Services' },
  { href: '#about', label: 'About' },
  { href: '#contact', label: 'Contact' },
  { href: '/job', label: 'Jobs' },
];

export function Nav() {
  const { isAuthenticated } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuButton = useRef<HTMLButtonElement>(null);

  return (
    <header className="absolute inset-x-0 top-10 z-20">
      {/* Separate sign-in doors for creators and employees. */}
      <nav aria-label="Login" className="fixed inset-x-0 top-0 z-30 h-10 border-b border-white/10 bg-ink text-white">
        <div className="mx-auto flex h-full max-w-6xl items-center justify-end gap-5 px-6">
          <Link to="/creator" className="flex h-full items-center gap-2 text-xs text-white/70 transition-colors hover:text-white">
            <Camera aria-hidden="true" className="size-3.5 shrink-0" />
            Creator Login
          </Link>
          <Link to={isAuthenticated ? '/pipeline' : '/login'} className="flex h-full items-center gap-2 text-xs text-white/70 transition-colors hover:text-white">
            <BriefcaseBusiness aria-hidden="true" className="size-3.5 shrink-0" />
            Employee Login
          </Link>
        </div>
      </nav>

      <div className="mx-auto flex max-w-6xl items-center justify-between gap-6 px-6 py-5 text-white">
        <a href="#top" aria-label="A2 Agency home" className="flex shrink-0 items-center gap-2.5">
          <img src="/favicon.svg" alt="" className="size-7 rounded-md" />
          <span className="text-sm font-medium tracking-[-0.025em]">A2 Agency</span>
        </a>

        <nav aria-label="Main" className="hidden items-center gap-6 text-[13px] text-white/75 lg:flex">
          {LINKS.map((link) => (
            <a key={link.href} href={link.href} className="transition-colors hover:text-white">
              {link.label}
            </a>
          ))}
        </nav>

        <a href="#contact" className="marketing-button hidden border border-white/25 bg-white/5 text-white hover:bg-white/10 lg:inline-flex">
          Start a project
        </a>

        <button
          ref={menuButton}
          type="button"
          aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
          aria-expanded={menuOpen}
          aria-controls="mobile-navigation"
          onClick={() => setMenuOpen((open) => !open)}
          onKeyDown={(event) => {
            if (event.key === 'Escape') {
              setMenuOpen(false);
              menuButton.current?.focus();
            }
          }}
          className="grid size-11 place-items-center rounded-lg border border-white/20 bg-ink/30 lg:hidden"
        >
          {menuOpen ? <X aria-hidden="true" className="size-5" /> : <Menu aria-hidden="true" className="size-5" />}
        </button>
      </div>

      {menuOpen && (
        <nav
          id="mobile-navigation"
          aria-label="Mobile"
          onKeyDown={(event) => {
            if (event.key === 'Escape') {
              setMenuOpen(false);
              menuButton.current?.focus();
            }
          }}
          className="mx-6 rounded-xl border border-white/15 bg-ink p-2 text-white lg:hidden"
        >
          {LINKS.map((link) => (
            <a key={link.href} href={link.href} onClick={() => setMenuOpen(false)} className="block rounded-md px-4 py-3 text-sm hover:bg-white/10">
              {link.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}
